import React from 'react';

import { Box, Typography, TypographyProps } from '@mui/material';
import _ from 'es-toolkit/compat';

export const TypographySection: React.FC = () => {
  return (
    <Box component="section">
      <Typography variant="h3">Typography</Typography>

      <Box display="flex" gap={4} mt={2}>
        <Box>
          <Box>
            {headings.map(variant => (
              <Typography key={variant} component="div" variant={variant}>
                {variant.toUpperCase()}
              </Typography>
            ))}
          </Box>

          <Box mt={2}>
            {subHeadings.map(variant => (
              <Typography key={variant} component="div" variant={variant}>
                {_.capitalize(variant)}
              </Typography>
            ))}
          </Box>
        </Box>

        <Box>
          <Box>
            {bodyVariants.map(variant => (
              <Typography key={variant} component="div" variant={variant}>
                {_.capitalize(variant)}
              </Typography>
            ))}
          </Box>

          <Box mt={2}>
            {buttonTextVariants.map(variant => (
              <Typography key={variant} component="div" variant={variant} mt={0.5}>
                {variant}
              </Typography>
            ))}
          </Box>

          <Box mt={2}>
            {inputTextVariants.map(variant => (
              <Typography key={variant} component="div" variant={variant} mt={0.5}>
                {variant}
              </Typography>
            ))}
          </Box>
        </Box>

        <Box>
          <Box>
            {otherVariants1.map(variant => (
              <Typography key={variant} component="div" variant={variant}>
                {variant}
              </Typography>
            ))}
          </Box>

          <Box mt={2}>
            {otherVariants2.map(variant => (
              <Typography key={variant} component="div" variant={variant} mt={0.5}>
                {variant}
              </Typography>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

type TypographyVariant = NonNullable<TypographyProps['variant']>;

const headings: TypographyVariant[] = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

const subHeadings: TypographyVariant[] = ['subtitle1', 'subtitle2'];

const bodyVariants: TypographyVariant[] = ['body1', 'body2', 'body3'];

const buttonTextVariants: TypographyVariant[] = ['buttonLarge', 'buttonMedium', 'buttonSmall'];

const inputTextVariants: TypographyVariant[] = [
  'inputText',
  'inputLabel',
  'inputHelperText',
  'menuItem',
];

const otherVariants1: TypographyVariant[] = ['overline', 'caption'];

const otherVariants2: TypographyVariant[] = [
  'avatarInitials',
  'badgeLabel',
  'chip',
  'tooltip',
  'tableHeader',
];
